<div class='CreateAccount__header d-flex flex-row'>
  <div class='flex-grow-1'>
    <h4 class='title__page'>Create account</h4>
  </div>
  <div class='flex-grow-0'>
    <app-button
      [color]="'blue'"
      [route]="'/messages'"
      [style]="'outline'"
      size='small'
      text='Back to Inbox'></app-button>
  </div>
</div>
<div *ngIf='componentReady' class='CreateAccount'>
  <form [formGroup]='formGroup'>
    <div class='CreateAccount-header d-flex flex-row'>
      <div class='flex-grow-0'>
        <h4>Create new:</h4>
      </div>
      <div class='flex-grow-1 text-left ps-3'>
        <mat-radio-group
        (change)='onUserTypeChange($event)'
          aria-label='Select an user type'
          formControlName='user_type'>
          <mat-radio-button class='me-2' value='user'>User</mat-radio-button>
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='manager'
          >Manager
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='partner'
          >Partner
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='vsm'
          >Edge
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='master'
          >Admin
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='franchisee'
          >Franchisee
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class='CreateAccount-body d-flex flex-column'>
      <app-text-field
        class='my-3'
        formControlName='email'
        placeholder='Enter unique account email'></app-text-field>
      <div *ngIf='emailTakenError' class='alert alert-danger'>
        <p class='mb-0'>Email is already in use</p>
      </div>
      <ng-container *ngIf="user_type.value === 'master' || user_type.value === 'partner' || user_type.value === 'vsm' || user_type.value === 'franchisee'">
        <app-text-field
          class='my-3'
          formControlName='password'
          [canCopy]="true"
          type="password"
          [allowViewPassword]='true'
          placeholder='Enter password'></app-text-field>
          <div class="alert alert-warning">
            <p>Only admin, edge, partner, and franchisee accounts require a predefined password. Please share this password with the person, who will use this account</p>
          </div>
        </ng-container>
      <app-text-field
        class='my-3'
        formControlName='first_name'
        placeholder='Enter first name'></app-text-field>
      <app-text-field
        class='my-3'
        formControlName='last_name'
        placeholder='Enter last name'></app-text-field>
      <app-text-field
        class='my-3'
        formControlName='company'
        placeholder='Enter company'></app-text-field>
      <ng-container *ngIf="user_type.value === 'franchisee'">
        <app-select
          [items]='franchiseeEntityTypes'
          formControlName='entity_type'
          class="my-3"
          label='Entity type'></app-select>
        <app-text-field
          class='my-3'
          formControlName='signer_title'
          placeholder='Signer title (e.g. Owner)'></app-text-field>
      </ng-container>
      <app-select
        [items]='getCountryItems()'
        formControlName='country'
        class="my-3"
        label='Select country'></app-select>
      <app-select
        *ngIf="country.value"
        [items]="getTimezones()"
        class="my-3"
        formControlName='time_zone'
        label='Selected Time Zone'></app-select>
      <app-select
        *ngIf="country.value"
        [items]="getStates()"
        class="my-3"
        formControlName='state'
        label='State'></app-select>
      <app-text-field
        class="my-3"
        formControlName='zip'
        placeholder='Zip Code...'></app-text-field>
      <app-text-field
        class="my-3"
        formControlName='address1'
        placeholder='Address 1'></app-text-field>
      <app-text-field
        class="my-3"
        formControlName='address2'
        placeholder='Address 2'></app-text-field>
      <app-text-field
        class="my-3"
        formControlName='phone_number'
        placeholder='Phone number: e.g. (555) 123-4567'
        type='tel'></app-text-field>
        <app-text-field
        class="my-3"
        formControlName='city'
        placeholder='City'></app-text-field>
        <app-select
        *ngIf="discounts.length > 0 && user_type.value === 'user'"
        [items]="discounts"
        class="my-3"
        formControlName='discount'
        label='Team code'></app-select>
    </div>
    <div class='CreateAccount-footer d-flex flex-row justify-content-end'>
      <app-button
        [Click]='createButton.onClick'
        [color]='createButton.color'
        [size]='createButton.size'
        [style]='createButton.style'
        [text]='createButton.text'
        [observeApi]="true"
        class='my-3'></app-button>
    </div>
  </form>
</div>
